export default {
  label: {
    myReport: '我的报告'
  }
}
